<template>
    <div>
        <div>
            Sebelum memulai mengisi formulir, mohon untuk siapkan
            <ul>
                <li>Foto KTP</li>
                <li>Foto Selfie dengan KTP</li>
                <li>Foto Selfie di tempat Usaha</li>
            </ul>
        </div>
        <v-form ref="form" v-model="valid" lazy-validation>
            <v-col cols="12" lg="6" md="6">
                <v-card>
                    <v-card-title class="title font-weight-regular justify-space-between">
                        <span>Pengajuan Kredit Modal Kerja</span>
                    </v-card-title>
                    <v-card v-if="reqloan.msg.length>2" elevation="0">
                        <v-card-title>
                            <v-alert dense  outlined type="error">
                                INFO: {{reqloan.msg}}
                            </v-alert>
                        </v-card-title>
                    </v-card>
                    <v-card elevation="0">
                        <v-card-title class="title font-weight-regular justify-space-between">
                            <span>Upload Foto</span>
                        </v-card-title>
                        <v-card-text>
                            <v-col cols="12" lg="12" md="12">
                                <v-layout align-center align-content-center justify-center row wrap class="">
                                    <v-flex lg4 sm4 xs12>
                                        <ImageUpload v-bind:key="1" value="reqloan.imagektp" v-model="reqloan.imagektp" @gambar="changektp" label="Foto KTP"/>
                                    </v-flex>
                                    <v-flex lg4 sm4 xs12>
                                        <ImageUpload  v-bind:key="2" v-model="reqloan.imageselfie" @gambar="changeselfie" label="Foto Selfie+KTP"/>
                                    </v-flex>
                                    <v-flex lg4 sm4 xs12>
                                        <ImageUpload  v-bind:key="3" v-model="reqloan.imagebusiness" @gambar="changeimageusaha" label="Foto diri ditempat usaha"/>
                                    </v-flex>
                                </v-layout>
                            </v-col>
                        </v-card-text>
                    </v-card>
                    <v-card elevation="0">
                        <v-card-title class="title font-weight-regular justify-space-between">
                            <span>Data Diri</span>
                        </v-card-title>
                        <v-card-text>
                            <v-col cols="12" lg="12" md="6">
                            <v-text-field
                                    v-model="reqloan.name"
                                    :counter="50"
                                    :rules="nameRules"
                                    label="Nama Lengkap (Sesuai KTP)"
                                    required
                            ></v-text-field>
                            </v-col>
                            <v-col cols="12" lg="12" md="6">
                            <v-text-field
                                    v-model="reqloan.address"
                                    :counter="100"
                                    :rules="nameRules"
                                    label="Alamat Tinggal Sekarang"
                                    required
                            ></v-text-field>
                            </v-col>
                            <v-col cols="12" lg="12" md="6">
                                <v-text-field
                                        v-model="reqloan.phone"
                                        :counter="100"
                                        :rules="nameRules"
                                        label="Nomor HP"
                                        required
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" lg="12" md="6">
                                <v-text-field
                                        v-model="reqloan.ktp"
                                        :counter="50"
                                        :rules="nameRules"
                                        label="No KTP"
                                        required
                                ></v-text-field>
                            </v-col>
                        </v-card-text>
                    </v-card>
                    <v-card elevation="0">
                        <v-card-title class="title font-weight-regular justify-space-between">
                            <span>Data Usaha</span>
                        </v-card-title>
                        <v-card-text>
                            <v-col cols="12" lg="12" md="6">
                                <v-text-field
                                        v-model="reqloan.businessname"
                                        :counter="50"
                                        :rules="nameRules"
                                        label="Nama Bisnis Usaha"
                                        required
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" lg="12" md="6">
                                <v-text-field
                                        v-model="reqloan.businessaddress"
                                        :counter="100"
                                        :rules="nameRules"
                                        label="Alamat Usaha"
                                        required
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" lg="12" md="6">
                                <v-autocomplete
                                        v-model="reqloan.provinsi"
                                        hint="Pilih Provinsi"
                                        :items="provinsi"
                                        :loading="loading_provinsi"
                                        :search-input.sync="search"
                                        item-text="province"
                                        item-value="province_id"
                                        label="Provinsi"
                                        v-on:change="changeprovinsi"
                                        persistent-hint
                                        return-object

                                />
                            </v-col>
                            <v-col cols="12" lg="12" md="6">
                                <v-autocomplete
                                        v-model="reqloan.city"

                                        hint="Pilih Kabupaten/Kota"
                                        :items="city"
                                        label="Kabupaten/Kota"
                                        item-text="city_name"
                                        item-value="city_id"
                                        v-on:change="changecity"
                                        persistent-hint
                                        return-object

                                />
                            </v-col>
                            <v-col cols="12" lg="12" md="6">
                                <v-autocomplete
                                        v-model="reqloan.district"
                                        hint="Pilih Kecamatan"
                                        :items="kecamatan"
                                        label="Kecamatan"
                                        item-text="subdistrict_name"
                                        item-value="subdistrict_id"
                                        v-on:change="changekecamatan"
                                        persistent-hint
                                        return-object

                                />
                            </v-col>
                            <v-col cols="12" lg="12" md="6">
                                <v-text-field
                                        v-model="reqloan.businesswebsite"
                                        :counter="50"
                                        :rules="nameRules"
                                        label="Website"
                                        required
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" lg="12" md="6">
                                <v-text-field
                                        v-model="reqloan.businessphone"
                                        :counter="50"
                                        :rules="nameRules"
                                        label="Nomor Telpon"
                                        required
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" lg="4" md="6">
                                <v-text-field
                                        v-model="reqloan.businessyear"
                                        value="0"
                                        type="number"
                                        label="Mulai Usaha (Tahun)"
                                        required
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" lg="6" md="6">
                                <v-text-field
                                        v-model="reqloan.businesscapital"
                                        value="0"
                                        type="number"
                                        label="Modal Awal (Rp)"
                                        required
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" lg="6" md="6">
                                <v-text-field
                                        v-model="reqloan.businesscustomer"
                                        value="0"

                                        type="number"
                                        label="Jumlah Pelanggan Aktif"
                                        required
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" lg="6" md="6">
                                <v-text-field
                                        v-model="reqloan.businessturnover"


                                        type="number"
                                        label="Rata2 Omset 1 Bulan"
                                        required
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" lg="6" md="6">
                                <v-text-field
                                        v-model="reqloan.businessprofit"

                                        type="number"
                                        label="Rata2 Laba Bersih"
                                        required
                                ></v-text-field>
                            </v-col>
                        </v-card-text>
                    </v-card>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-btn @click="setviewstate(0)" color="red" class="white--text" depressed >Kembali</v-btn>
                        <v-spacer/>
                        <v-btn color="primary" @click="kirim" depressed >Kirim</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-form>
    </div>
</template>

<script>
    import {mapActions, mapState} from "vuex";
    import ImageUpload from "@/components/irmacapital/ImageUpload";

    export default {
        name: "loanformrequest",
        components: {ImageUpload},
        data: () => ({
            valid: false,
            search: '',
            ruleimages: [
                value => !value || value.size < 1000000 || 'Ukuran foto tidak lebih dari 1 MB!',
            ],
            nameRules: [
                v => !!v || 'Name is required',
                v => (v && v.length > 2 && v.length<50) || 'Name must be less than 50 characters',
            ],
        }),
        mounted() {
            this.getProvinsi()
            this.getReqData()
        },
        computed: {
            ...mapState('Loan',['viewstate','reqloan']),
            ...mapState('Location',['provinsi','city','kecamatan','loading_provinsi','loading_city','loading_kecamatan'])
        },
        methods: {
            ...mapActions('Loan',['setviewstate','doRequestCapital','getReqData']),
            ...mapActions('Location',['getProvinsi','getCity','getKecamatan']),
            kirim(){
                this.$confirm('Data yang dimasukkan saya yakin sudah benar dan dapat dipertanggung jawabkan, ajukan sekarang?', { color: 'green',title:'Konfirmasi',icon:'fa-question' }).then(res => {
                    if (res) {
                        this.doRequestCapital(this.reqloan)
                    }
                })
            },
            changektp(e){
                this.$store.commit('Loan/setimagektp',e)
            },
            changeselfie(e){
                this.$store.commit('Loan/setimageselfie',e)
            },
            changeimageusaha(e){
                this.$store.commit('Loan/setimagebusiness',e)
            },
            changeprovinsi(e){
                console.log(e.province);
                this.$store.commit('Loan/setProvince',e)
                this.getCity(e)
            },
            changecity(e){
                this.$store.commit('Loan/setCity',e)
                this.getKecamatan(e)
            },
            changekecamatan(e){
                this.$store.commit('Loan/setKecapatan',e)
               console.log(e)
            }
        }
    }
</script>

<style scoped>

</style>
